// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__GU9Yn","content":"index_content__mgxuA"};